import React, { useState } from 'react';
import { API_BASE_URL } from '../services/api';

function WalletModal({ user, onClose, balance }) {
    const [amount, setAmount] = useState('');
    const [loading, setLoading] = useState(false);

    const loadRazorpay = () => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    // ... existing logic ...
    const [transactions, setTransactions] = useState([]);

    React.useEffect(() => {
        if (user) {
            fetch(`${API_BASE_URL}/payment/transactions?username=${user.username}`)
                .then(res => res.json())
                .then(data => {
                    if (data.success) setTransactions(data.transactions);
                })
                .catch(err => console.error("Error fetching transactions:", err));
        }
    }, [user, balance]); // Refresh when balance changes

    const handlePayment = async () => {
        // ... (Keep existing logic, assumes user wants UPI flow which Razorpay handles)
        // ...
        // Note: For simulation without actual Razorpay keys, we might want a 'Simulate UPI' bypass if keys are missing?
        // But assuming keys are there or user understands. To be safe, let's add a "Quick Add (Test)" logic if needed?
        // strict request: "add amount using upi". Razorpay supports UPI.

        // ... previous implementation ...
        if (!user) {
            alert("Please login to add money.");
            return;
        }

        const res = await loadRazorpay();
        if (!res) {
            alert('Razorpay SDK failed to load. Are you online?');
            return;
        }

        setLoading(true);

        try {
            // 1. Create Order
            const result = await fetch(`${API_BASE_URL}/payment/order`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount: amount, username: user.username })
            });

            const orderData = await result.json();

            if (!orderData.success) {
                alert("Server error: " + orderData.message);
                setLoading(false);
                return;
            }

            // 2. Open Razorpay options
            const options = {
                key: orderData.key_id,
                amount: orderData.amount,
                currency: "INR",
                name: "Pondy Connect",
                description: "Wallet Recharge",
                order_id: orderData.order_id,
                handler: async function (response) {
                    // 3. Verify Payment
                    const verifyRes = await fetch(`${API_BASE_URL}/payment/verify`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                            amount: amount,
                            username: user.username
                        })
                    });

                    const verifyData = await verifyRes.json();
                    if (verifyData.success) {
                        alert(`Payment Successful! New Wallet Balance: ₹${verifyData.new_balance}`);
                        setLoading(false);
                        // Refresh transactions
                        fetch(`${API_BASE_URL}/payment/transactions?username=${user.username}`)
                            .then(res => res.json())
                            .then(data => { if (data.success) setTransactions(data.transactions); });

                        // Close or just update balance display if passed as prop func? 
                        // Ideally we should update parent state. But onClose + reload is what was there.
                        onClose();
                        window.location.reload();
                    } else {
                        alert("Payment verification failed");
                        setLoading(false);
                    }
                },
                prefill: {
                    name: user.name,
                    contact: user.phone || '9999999999'
                },
                theme: { color: "#F0C14B" }
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    };

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0 }}>My Wallet</h3>
                    <button onClick={onClose} style={styles.closeBtnIcon}>×</button>
                </div>

                <div style={styles.balanceCard}>
                    <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>Current Balance</p>
                    <h2 style={{ margin: '5px 0', color: '#2E7D32', fontSize: '2rem' }}>₹ {balance}</h2>
                </div>

                <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px', marginBottom: '12px' }}>
                        {[
                            { amt: 100, label: '₹100', bonus: '🎁 Scratch' },
                            { amt: 300, label: '₹300', bonus: '🎁 Scratch' },
                            { amt: 500, label: '₹500', bonus: '🔥 ₹100 Extra' },
                            { amt: 1000, label: '₹1000', bonus: '⭐ ₹250 Extra' },
                        ].map((pkg) => (
                            <button
                                key={pkg.amt}
                                type="button"
                                onClick={() => setAmount(pkg.amt.toString())}
                                style={{
                                    padding: '8px 4px',
                                    borderRadius: '10px',
                                    border: amount === pkg.amt.toString() ? '2px solid #f59e0b' : '1px solid #e2e8f0',
                                    background: amount === pkg.amt.toString() ? '#fffbeb' : '#f8fafc',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    fontWeight: '700',
                                    fontSize: '12px'
                                }}
                            >
                                <div>{pkg.label}</div>
                                <div style={{ fontSize: '9px', color: '#16a34a', marginTop: '2px' }}>{pkg.bonus}</div>
                            </button>
                        ))}
                    </div>

                    <div style={{ display: 'flex', gap: '10px' }}>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter amount (e.g. 500)"
                            style={styles.input}
                        />
                        <button onClick={handlePayment} style={styles.payBtn} disabled={loading || !amount}>
                            {loading ? "PROCESSING..." : "ADD MONEY"}
                        </button>
                    </div>
                </div>

                <div style={{ textAlign: 'left' }}>
                    <h4 style={{ fontSize: '0.9rem', color: '#333', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Last transactions</h4>
                    <div style={styles.transactionList}>
                        {transactions.length === 0 && <p style={{ fontSize: '0.8rem', color: '#999', padding: '10px 0' }}>No transactions yet.</p>}
                        {transactions.map((txn, index) => (
                            <div key={index} style={styles.txnItem}>
                                <div>
                                    <div style={{ fontSize: '0.85rem', fontWeight: '500' }}>{txn.Description}</div>
                                    <div style={{ fontSize: '0.75rem', color: '#888' }}>{txn.Timestamp}</div>
                                </div>
                                <div style={{ color: txn.Type === 'Credit' ? 'green' : 'red', fontWeight: 'bold' }}>
                                    {txn.Type === 'Credit' ? '+' : '-'} ₹{txn.Amount}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
    },
    modalContent: {
        backgroundColor: 'white', padding: '25px', borderRadius: '12px', width: '380px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.12)', textAlign: 'center', maxHeight: '90vh', overflowY: 'auto'
    },
    balanceCard: {
        background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #e9ecef'
    },
    input: {
        flex: 1, padding: '12px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '1rem'
    },
    payBtn: {
        backgroundColor: '#F7CA00', border: 'none', padding: '0 20px', borderRadius: '6px',
        fontWeight: 'bold', cursor: 'pointer', color: '#111', fontSize: '0.9rem'
    },
    transactionList: {
        marginTop: '10px', maxHeight: '150px', overflowY: 'auto'
    },
    txnItem: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f0f0f0'
    },
    closeBtnIcon: {
        background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#666'
    }
};

export default WalletModal;
